import React from 'react';

import Toggle from 'craft/containers/Toolbox/components/Toggle';
import ValueBox from 'craft/containers/Toolbox/components/ValueBox';
import { useMultiNodes } from 'craft/hooks';
import { PropToEdit } from 'craft/types';

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit;
}

const BoolPropField = ({ nodeIds, propToEdit }: Props) => {
  const { schema, value: currentValue } = propToEdit;

  const {
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  let value = schema.fieldType.defaultValue ?? false;
  if (currentValue !== undefined) {
    value = currentValue;
  }

  return (
    <ValueBox data-cy={`toolbox-property-wrapper-${schema.id}`} label={schema.name || schema.id}>
      <Toggle
        data-cy={`toolbox-property-${schema.id}`}
        id={schema.id}
        onClick={() => setProps({ [schema.id]: !value })}
        isActive={value}
      />
    </ValueBox>
  );
};

export default BoolPropField;
